import type { SVGProps } from 'react'

interface FinanceIconProps extends SVGProps<SVGSVGElement> {}

export function FinanceIcon(props: FinanceIconProps) {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_663_843)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.4293 10.9092C17.309 10.9092 20.4587 13.9803 20.4587 17.7628C20.4587 21.5456 17.309 24.6165 13.4293 24.6165C9.54952 24.6165 6.39991 21.5456 6.39991 17.7628C6.39991 13.9803 9.54952 10.9092 13.4293 10.9092ZM12.9377 15.0894V14.6736C12.9377 14.409 13.1579 14.1943 13.4293 14.1943C13.7007 14.1943 13.9209 14.409 13.9209 14.6736V15.0894H14.864C15.1354 15.0894 15.3556 15.3041 15.3556 15.5687C15.3556 15.8331 15.1354 16.048 14.864 16.048H13.9209V17.3273H14.0471C14.9282 17.3273 15.6423 18.0235 15.6423 18.8827V18.9685C15.6423 19.8274 14.9282 20.5239 14.0471 20.5239H13.9209V20.8521C13.9209 21.1164 13.7007 21.3314 13.4293 21.3314C13.1579 21.3314 12.9377 21.1164 12.9377 20.8521V20.5239H11.9946C11.7232 20.5239 11.5029 20.3089 11.5029 20.0445C11.5029 19.7799 11.7232 19.5652 11.9946 19.5652H12.9377V18.2859H12.8115C11.9304 18.2859 11.2163 17.5895 11.2163 16.7306V16.6447C11.2163 15.7856 11.9304 15.0894 12.8115 15.0894H12.9377ZM13.9209 18.2859V19.5652H14.0471C14.3852 19.5652 14.6591 19.2979 14.6591 18.9685V18.8827C14.6591 18.553 14.3852 18.2859 14.0471 18.2859H13.9209ZM12.9377 16.048H12.8115C12.4734 16.048 12.1995 16.3151 12.1995 16.6447V16.7306C12.1995 17.06 12.4734 17.3273 12.8115 17.3273H12.9377V16.048ZM5.50748 16.6181C5.67929 15.4787 6.10419 14.4191 6.72448 13.4951V9.93368C6.72448 9.5913 6.44005 9.31398 6.08889 9.31398H3.65463C3.30348 9.31398 3.01904 9.5913 3.01904 9.93368V15.9984C3.01904 16.3405 3.30348 16.6181 3.65463 16.6181H5.50748ZM20.1341 13.4951C20.7544 14.4193 21.179 15.4787 21.3511 16.6181H23.2039C23.5551 16.6181 23.8395 16.3405 23.8395 15.9984V1.26985C23.8395 0.927471 23.5551 0.650146 23.2039 0.650146H20.7697C20.4185 0.650146 20.1341 0.927471 20.1341 1.26985V13.4951ZM8.72406 11.4465C9.79132 10.6894 11.0567 10.1829 12.4295 10.0158V7.04549C12.4295 6.70336 12.1451 6.42603 11.7939 6.42603H9.35965C9.0085 6.42603 8.72406 6.70336 8.72406 7.04549V11.4406V11.4465ZM14.4291 10.0158C15.8021 10.1829 17.0675 10.6894 18.1345 11.4465V11.4406V4.15779C18.1345 3.81566 17.8501 3.53809 17.4989 3.53809H15.0647C14.7135 3.53809 14.4291 3.81566 14.4291 4.15779V10.0158Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_663_843">
          <rect
            width="25.3333"
            height="24.7"
            fill="white"
            transform="translate(0.763184 0.283325)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
